exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trainig-chart{display:flex;margin:30px auto;width:1162px}.setting{width:274px;height:404px;border-radius:3px;box-shadow:0 10px 60px 0 hsla(0,0%,85%,.43);background-color:#fff;margin-right:21px;padding:20px}.main-eye{width:87px;height:20px;font-family:NanumBarunGothicOTF;font-size:18px;line-height:2.5;margin-bottom:20px}.setting span{padding-left:22px}.tranging-chart-in{padding:20px;width:867px;height:404px;border-radius:3px;box-shadow:0 10px 60px 0 hsla(0,0%,85%,.43);background-color:#fff}.trainging-box{width:867px;height:202px;border-radius:3px}.trainging-box .box-id{font-family:NanumBarunGothicOTF;font-size:20px;margin-top:10px}.slider{height:50px;margin-top:30px}.slider-m{height:50px;margin-top:20px}.slider-descript{height:19px;font-family:NanumBarunGothicUltraLightOTF;font-size:16px;margin-right:31px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b54c0c2c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PatientCenter/TrainingChart.vue
// module id = 247
// module chunks = 0